import { Box, styled } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

interface GiftCardCardProps {
    sx?: SxProps<Theme>;
}

export const GiftCardCard = styled(Box)<GiftCardCardProps>(({ sx = {} }) => ({
    background: `white`,
    userSelect: `none`,
    display: `flex`,
    flexFlow: `column`,
    justifyContent: `space-between`,
    padding: `15px 10px`,
    width: `180px`,
    boxShadow: `rgba(0, 0, 0, 0.24) 0px 1px 5px`,
    borderRadius: 12,
    textAlign: `center`,
    marginBottom: 20,
    ...(sx as Record<string, string | number>),
}));

export const CardDelivery = styled(Box)({
    height: `30px`,
    borderRadius: `12px`,
    background: `#f3f4f6`,
    margin: `0`,
    lineHeight: `32px`,
    color: `#949494`,
    letterSpacing: `0.02em`,
    fontSize: 14,
    display: `inline-block`,
    padding: `0 15px`,
    fontWeight: `600`,
});

export const CardLogo = styled(`img`)({
    width: `70%`,
    marginBottom: `5px`,
    borderRadius: 8,
});

export const MerchantName = styled(Box)({
    fontSize: 14,
    fontWeight: 400,
});
